/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { size } from 'lodash';
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import HttpRequestError from '../../utils/HttpRequetsError';

export async function getDanhSachDonHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.quanLyDonHangApiPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function updateStatusOrderApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.updateStatusOrderPath, payload);
  if (size(data) > 0) return data;  
  throw new HttpRequestError(data.error, data.message);
}

export async function getTotalQuanLyDonHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.totalQuanLyDonHangApiPath, {
    params: payload
  });
  if (!!data) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getListChatBillAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListChatInBillPath+'/'+payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postChatInBillAPI(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postChatInBillPath, payload);
  if (size(data) > 0) return data;  
  throw new HttpRequestError(data.error, data.message);
}

export async function getCountHeaderQlDonHangApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.totalHeaderQuanLyDonHangApiPath, {
    params: payload
  });
  if (size(data) > 0) return data;  
  throw new HttpRequestError(data.error, data.message);
}